import { defaults as defaultControls } from "ol/control";
import ScaleLineControl from "ol/control/ScaleLine";
import ZoomSliderControl from "ol/control/ZoomSlider";

/**
 * 地図に表示するコントロールを生成する。
 *
 * @returns コントロール
 */
export const createControls = () => {
    const controls = defaultControls({
        attribution: true,
        rotate: false,
        zoom: true,
        attributionOptions: {
            collapsible: true,
            collapsed: true,
        },
    });

    controls.push(new ScaleLineControl());
    controls.push(new ZoomSliderControl({}));

    return controls;
};
